import React from 'react';

function SkillsSection() {
  const skillsData = [
    {
      category: 'Programming Languages',
      list: ['Java', 'PHP', 'JavaScript', 'Go Lang', 'Python']
    },
    {
      category: 'Frameworks & ORM',
      list: ['Spring (MVC, Boot, Security, Cloud)', 'Laravel', 'Vue.js', 'React.js', 'jQuery', 'Fast API', 'Hibernate', 'JPA']
    },
    {
      category: 'Cloud & DevOps',
      list: ['AWS (IAM, EC2, ELB, ASG, S3, Aurora & RDS, DynamoDB, Athena, Lambda, API Gateway)', 'Docker', 'CI/CD']
    },
    {
      category: 'Databases & Caching',
      list: ['MySQL', 'MariaDB', 'Oracle DB', 'Snowflake', 'DynamoDB', 'Athena', 'Redis', 'In-Memory Caching']
    },
    {
      category: 'Architecture & Design Patterns',
      list: ['Microservices', 'Monolithic', 'SOLID Principles', 'Design Patterns (Singleton, Factory, Builder, DI, Service Discovery, API Gateway, Circuit Breaker, Saga, DB per Service)']
    },
    {
      category: 'Tools & Version Control',
      list: ['Git', 'SVN', 'GitHub', 'GitLab', 'BitBucket', 'Maven', 'IntelliJ IDEA', 'PHPStorm', 'Postman', 'Docker', 'Vagrant', 'Swagger']
    },
    {
      category: 'Security',
      list: ['OAuth', 'JWT', 'HTTPS', 'Cross-Site Scripting (XSS)', 'CSRF']
    },
    {
      category: 'Messaging & Web Tech',
      list: ['Apache Kafka', 'HTML5', 'CSS3', 'RESTful Services']
    },
    {
      category: 'Java Core & Advanced',
      list: ['Multithreading & Concurrency', 'Java Stream API', 'Functional Programming (Lambdas)']
    },
    {
      category: 'Methodologies',
      list: ['Agile', 'Scrum', 'Test-Driven Development (TDD)']
    },
    {
      category: 'Project Management & Collaboration Tools',
      list: ['Jira', 'Trello', 'Asana', 'Confluence']
    },
    {
      category: 'Soft Skills',
      list: ['Strong communication', 'problem solving', 'teamwork', 'time management', 'leadership']
    }
  ];

  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-center text-text-white mb-16 relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px]">
        My Skills
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {skillsData.map((skillGroup, index) => (
          <div key={index} className="bg-bg-light p-6 rounded-lg shadow-md border border-border-subtle">
            <h3 className="text-xl font-semibold text-accent-red mb-3">{skillGroup.category}</h3>
            <ul className="list-disc text-text-gray space-y-1">
              {skillGroup.list.map((skill, skillIndex) => (
                <li key={skillIndex}>{skill}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default SkillsSection;